import React, { useEffect, useState } from 'react'
import { Icon } from '@lightspeed/design-system-react'
import { trackUserEvent } from '@vend/utilities'
import { PAYMENT_TYPES } from '@vend/business-components'
import {
  useIsCalculatingSale,
  useRegisterManager,
} from '../../../ng-compat/hooks'
import { WEB_REGISTER } from '../../web-register.constant'
import { useAppSelector } from '../../../state/hooks'
import {
  selectOutstandingBalance,
  selectSaleLocalId,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { getFeatureFromCache } from '../../../util/feature-cache'
import { useLSQuickPay } from './useLSQuickPay'
import { SalePaymentButton } from './sale-payment-button/sale-payment-button'
import { useTransitionToPaymentScreen } from './sale-payment-button/use-transition-to-payment-screen'

export const SalePayments = () => {
  const { showQuickPayButton, disableQuickPayButton } = useLSQuickPay()
  const transitionToPaymentScreen = useTransitionToPaymentScreen(true)
  const saleCalculationRunning = useIsCalculatingSale()
  const registerManager = useRegisterManager()
  const outstandingBalance = useAppSelector(selectOutstandingBalance)
  const saleId = useAppSelector(selectSaleLocalId)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const handleQuickPayClick = () => {
    setIsTransitioning(true)
    trackUserEvent(WEB_REGISTER.DISPLAY_NAME, 'Payment type selected', {
      amount: outstandingBalance,
      paymentTypeId: PAYMENT_TYPES.LSPAY,
      registerSaleId: saleId,
      registerId: registerManager.getActiveRegister().id,
      isQuickPay: true,
      quickPayFeatureFlag: getFeatureFromCache(
        'lspay_pay_with_quick_pay_experiment'
      ),
    })
  }

  useEffect(() => {
    if (isTransitioning && !saleCalculationRunning && !disableQuickPayButton) {
      transitionToPaymentScreen()
      setIsTransitioning(false)
    }
  }, [
    disableQuickPayButton,
    isTransitioning,
    saleCalculationRunning,
    transitionToPaymentScreen,
  ])

  return (
    <div className="sale-action-bar" aria-label="payment button groups">
      {showQuickPayButton && (
        <button
          type="button"
          className="vd-btn vd-btn--supplementary vd-ml1"
          data-cy="quick-pay-btn"
          data-testid="quick-pay-btn"
          onClick={handleQuickPayClick}
          disabled={disableQuickPayButton}
        >
          <Icon icon="fa-credit-card"></Icon>
        </button>
      )}
      <SalePaymentButton />
    </div>
  )
}
